import { util } from 'vue'
import _ from 'lodash'

export default {
  data () {
    return {
      items: [],
      query: '',
      current: -1,
      loading: false,
      queryParamName: 'q',
      limit: 20,
      options: {},
      takeFirstItemOnHit: true,
      hitRequest: false

    }
  },

  computed: {
    hasItems () {
      // console.log(this.items.length);
      return this.items.length > 0
    },

    isEmpty () {
      return !this.query
    },

    isDirty () {
      return !!this.query
    },
    
    nothingFound () {
      return (this.isDirty && !this.hasItems && !this.loading)
    }
    
    
  },

  methods: {
    
    reset () {
      this.items = []
      this.query = ''
      this.loading = false
      this.hitRequest = false
      this.options = {}
    },
    
    update () {
      if (!this.query) {
        return this.reset()
      }

      if (this.query.length == 1 ) {
        this.onBeginSearch();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return
      }
      

      this.loading = true
      
      this.updateDebounce()

    },
    
    
    updateDebounce: _.debounce( function () {

      this.fetch().then((response) => {
        if (this.query) {
          let data = response.data
          //data = this.prepareResponseData ? this.prepareResponseData(data) : data
          this.items = this.limit ? data.slice(0, this.limit*2) : data
          this.current = -1
          this.loading = false
          // währen des laden wurde Enter gedrückt. Wird jetzt nach dem laden ausgeführt.
          if(this.hitRequest){
            this.hit();
          }

        }
      }, (response) => {
        //console.log('typeahead.common:fetch')
        //console.log(response)
      })
      },250),
  

    fetch () {
      if (!this.$http) {
        return util.warn('You need to install the `vue-resource` plugin', this)
      }

      if (!this.src) {
        return util.warn('You need to set the `src` property', this)
      }

      if (this.queryParamName === '' && this.src.substr(-1) !== '/') {
        this.src += '/'
      }

      const src = this.queryParamName
        ? this.src
        : this.src + this.query
      
      /* vue-rescaource >= 0.9.0 */
      const options = {params: Object.assign({[this.queryParamName]: this.query, limit: this.limit}, this.options) };
      
      //console.log(options);
      //console.log(options.params);
      
      return this.$http.get(src, options);
      
      
      /* vue-rescaource < 0.9.0
      const params = this.queryParamName
        ? Object.assign({ [this.queryParamName]: this.query }, this.data)
        : this.data

      return this.$http.get(src, params)
      */
    },


    setActive (index) {
      this.current = index
    },

    activeClass (index) {
      return {
        active: this.current === index
      }
    },

    hit(event) {
      
      if(typeof event != "undefined"){
        console.log(event);
        event.preventDefault();
      }
        
      // if loading than we wait, until loading finishd see this.fetch()
      if(this.loading){
        this.hitRequest = true;
        return;
      }

      if (this.current !== -1) {
        this.onHit(this.items[this.current])
      }else{
        if(this.takeFirstItemOnHit && typeof this.items[0] != "undefined"){
          this.onHit(this.items[0])
        }else{
          if(!!this.query){
            this.onHitNew(this.query);
            this.query = "";
          }
        }
      }

    },

    up () {
      if (this.current > 0) {
        this.current--
      } else if (this.current === -1) {
        this.current = this.items.length - 1
      } else {
        this.current = -1
      }
    },

    down () {
      if (this.current < this.items.length - 1) {
        this.current++
      } else {
        this.current = -1
      }
    },

    onBeginSearch () {
      // DO nothing her. Override this Method
    },
    
    onHitNew () {
      util.warn('You need to implement the `onHitNew` method', this)
    },
    
    onHit () {
      util.warn('You need to implement the `onHit` method', this)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/typeahead.common.js